var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminPanelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M682.88-277q25.47 0 43.29-18.18Q744-313.35 744-338.06q0-24.7-18.12-42.82T683.06-399q-24.71 0-42.88 17.71-18.18 17.7-18.18 43Q622-313 640.13-295q18.12 18 42.75 18Zm-.38 121q32.5 0 59-13.5T785-208q-24-14-49.31-21-25.31-7-52.65-7t-53.19 7Q604-222 581-208q17 25 43 38.5t58.5 13.5ZM480-134q-114-36-191-141.5T212-518v-206l268-100 268 100v239q-5-1-11.5-3t-10.5-3v-219l-246-90-246 90v192q0 72 22.5 133.5t60 110q37.5 48.5 85 81T500-149l3-1q2 0 4 2l3 3q-8 4-15.5 6.5T480-134Zm203.98 2q-60.02 0-102-42T540-276q0-60.76 41.97-102.88T684.48-421Q744-421 786-378.88q42 42.12 42 102.88 0 60-42 102t-102.02 42ZM480-475Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminPanelIcon);
export default __webpack_public_path__ + "static/media/admin-panel-icon.238bf676820d856b04d271c32590fbae.svg";
export { ForwardRef as ReactComponent };